<script setup>
import { ref,reactive,watch,onMounted,inject } from 'vue';
import InventoryRoom from './inventoryRoom/InventoryRoom.vue';
import InventoryWareHouse from './inventoryWarehouse/InventoryWareHouse.vue';
import InventoryModalForm from './InventoryModalForm.vue';
import InventorySpoil from './inventorySpoil/InventorySpoil.vue';
import HeaderContent from '@/components/HeaderContent.vue';
import ActionContent from '@/components/ActionContent.vue';
import StatisticData from '@/components/StatisticData.vue';
import InventoryTable from '@/components/DataTable.vue';
import iconProduct from '../../../public/icons/box-open.svg';
import iconItem from '../../../public/icons/boxes.svg';
import iconSpoil from '../../../public/icons/damage.svg';
import iconOverall from '../../../public/icons/square-poll-vertical.svg';



const repositories = inject('repositories');
const invetoryOverallRepository = repositories ? repositories.inventoryOverall : null;
const statistics = ref([])
const inventoryOverallData = ref([])
const currentPage = ref(1)
const inventoryName = ref('overall')
const inventoryModal = ref(false)
const inventoryRoomFilter = reactive({
    roomType : 'Select Type',
    roomNumber : 'Select Room',
   
    roomTypeOption : [
        {
            option : 'Select Type',
            room : ['Select Room'],
        },
        {
            option : 'Deluxe',
            room : ['Select Room','A03','A04',],
        }, 
        {
            option : 'Family',
            room : ['Select Room','B01','B03'],
        },
        {
            option : 'Super Deluxe',
            room : ['Select Room','C01','C03'],
        },
    ]
})
const fields = ref(
    [
    { key: 'item_name', label: 'Name',class: 'text-left pl-5 pr-0'},
    { key: 'type', label: 'Category',class: 'text-center pl-0 '},
    { key: 'warehouse', label: 'Ware House',class: 'text-center'},
    { key: 'room', label: 'Room',thClass:'text-center',tdClass:'text-center'},
    { key: 'defect', label: 'Defact',class: 'text-center'},
    { key: 'total', label: 'Total',thClass:'text-center',tdClass:'text-center'},
]
)

watch(()=>inventoryRoomFilter.roomType,()=>{
    
    inventoryRoomFilter.roomNumber = 'Select Room'
})


const getAll = async () => {
    await invetoryOverallRepository.getAll().then((res) => {
        const responseData = res.data.data
    inventoryOverallData.value = responseData.map(item => ({
        ...item,
        warehouse : item.warehouse === 0 ? '-' : item.warehouse,
        room : item.room === 0 ? '-' : item.room,
        defect : item.defect === 0 ? '-' : item.defect,
    }))
    console.log(res.data.data)
    const totalOverall = parseInt(res.data.total_product) + parseInt(res.data.total_item) + parseInt(res.data.total_defect)
    statistics.value = [
        {key : 'Products', label : 'Total', value : parseInt(res.data.total_product), color: 'primary', icon: iconProduct},
        {key : 'Items', label : 'Total', value : parseInt(res.data.total_item), color: 'primary', icon: iconItem},
        {key : 'Defect', label : 'Total', value : parseInt(res.data.total_defect), color: 'danger', icon: iconSpoil},
        {key : 'Overall', label : 'Total', value : totalOverall, color: 'primary', icon: iconOverall},
    ];
    }).catch(err => {
    console.error(err)
    })
};
    
onMounted(() => {
    getAll();
});

</script>

<template>
    <!-- Header -->
    <HeaderContent title="Inventory"/>

    <ActionContent :filterDate="false" :cta="false"/>

    <!-- Statistic -->
    <StatisticData title="Inventory Statistics" :data="statistics"></StatisticData>
    
    <!-- Modalform -->
    <InventoryModalForm v-model="inventoryModal" @update:modal="modal = $event"></InventoryModalForm>

    <InventoryTable v-if="inventoryName == 'overall'" :data="inventoryOverallData" :header="fields" :currentPage="currentPage"></InventoryTable>

    <!-- room -->
    <InventoryRoom v-if="inventoryName === 'room'" v-model="inventoryRoomFilter"></InventoryRoom>

    <!-- warhouse -->
    

    <InventoryWareHouse v-if="inventoryName === 'warehouse'"></InventoryWareHouse>

    <!-- Spoil -->
    <InventorySpoil v-if="inventoryName === 'spoil'"></InventorySpoil>

</template>

<script>



// const data = [
//     {
//         id: 'I001',
//         name: 'Double Sheet',
//         category: 'Item',
//         warehouse: 62,
//         room: 18,
//         defact: 3,
//         total: 83,
//     },
//     {
//         id: 'I002',
//         name: 'Singgle Sheet',
//         category: 'Item',
//         warehouse: 43,
//         room: 21,
//         defact: 4,
//         total: 68,
//     },
//     {
//         id: 'I003',
//         name: 'Bath Towel',
//         category: 'Item',
//         warehouse: 41,
//         room: 52,
//         defact: 2,
//         total: 95,
//     },
//     {
//         id: 'P001',
//         name: 'Tooth Paste',
//         category: 'Product',
//         warehouse: 186,
//         room: 72,
//         defact: 0,
//         total: 258,
//     },
//     {
//         id: 'P002',
//         name: 'Soft Drink',
//         category: 'Product',
//         warehouse: 261,
//         room: 102,
//         defact: 0,
//         total: 363,
//     },
//     {
//         id: 'P003',
//         name: 'Snacks',
//         category: 'Product',
//         warehouse: 242,
//         room: 133,
//         defact: 0,
//         total: 375,
//     },
    
// ]

// Room




</script>